import { useState } from 'react';

// NOTE: 
// 10-05-2023: 
// This is an earlier attempt at creating useToken; This is used by ./useUser.jsx
// This hook should be removed eventually after managing any dependencies

// useTokenLS => useTokenLocalStorage

export const useTokenLS = () => {
    const [token, setTokenInternal] = useState(() => {
        return localStorage.getItem('token');
    });

    const setToken = newToken => {
        localStorage.setItem('token', newToken);
        setTokenInternal(newToken);
    }

    return [token, setToken];
}